<template>
  <div>
    <div class="right-title">
      <span>冻结资金管理</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-input
          class="search"
          type="text"
          prepend="iconbianji1"
          placeholder="请输入机构名称"
          v-model="search"
        >
        </el-input>
        <el-button @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
        >

          <el-table-column
            prop="organization_name"
            label="机构名称 -- ID"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.organization_name}} -- {{scope.row.organization_id}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="organization_name"
            label="职位名称 -- ID"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.jobs_name}} -- {{scope.row.jobs_id}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="organization_name"
            label="候选人 -- ID"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.user_real_name}} -- {{scope.row.user_id}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="organization_name"
            label="推荐人 -- ID"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.tuijianren_name}} -- {{scope.row.tuijianren_id}}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="id"-->
          <!--            label="事件"-->
          <!--            align="center"-->
          <!--            id="hao"-->
          <!--          >-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>{{scope.row.ufa_type | til}}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="interviewtime"
            label="面试时间"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="ufa_freeze_price"
            label="金额"
            align="center"
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="btn-box">
                <!--                <el-button-->
                <!--                  class="btns"-->
                <!--                  type="primary"-->
                <!--                  v-if="scope.row.states === 2"-->
                <!--                  @click="handleEdit(scope.row.ufa_id)">发放-->
                <!--                </el-button>-->
                <!--                <el-button-->
                <!--                  class="btns"-->
                <!--                  type="primary"-->
                <!--                  v-if="scope.row.states === 3||scope.row.states === 6"-->
                <!--                  @click="handleKou(scope.row.ufa_id)">扣款-->
                <!--                </el-button>-->
                <el-button
                  class="btns"
                  type="primary"
                  v-if="scope.row.utf_state===0&&(scope.row.states === 3||scope.row.states === 6)"
                  @click="handleDelete(scope.row.ufa_id)">退费
                </el-button>
                <el-button
                  class="btns"
                  style="background: #aaa;color: #fff;"
                  v-else
                >退费
                </el-button>
              </div>
              <!--              <span class=''>已确认到账</span>-->
            </template>
          </el-table-column>

        </el-table>
        <div class="page-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "jgFrozen",
    data() {
      return {
        search: '',  // 搜索
        tableData: [],
        multipleSelection: [], //  选中的
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        }
      }
    },
    computed: {
      list() {
        let _list = JSON.parse(JSON.stringify(this.tableData))
        _list.map(item => {
          // 时间
          item.interviewtime = this.$tools.ZHDate(new Date(item.interviewtime * 1000), 1)

        })
        return _list
      },
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 2, 1)
      this.dongJieList()
    },
    methods: {

      toDetail(id) {
        console.log(id)
        // this.$router.push({
        //   path:'/home/hxrAdmin/hxrBiaoDanDetail/' + id
        // })
      },
      // 表单列表
      dongJieList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }

        this.$api.apiContent.jgZiJinDongJie({
          search: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id,
          type: 1
        }).then(res => {
          console.log(res)
           loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
        }).catch(() => {
           loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      // 发放
      handleEdit(id) {
        this.$confirm("此操作将发放", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.jgZiJinDongJieFK({
            ufa_id: id,
            admin_id: this.user.id,
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.dongJieList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 扣款
      handleKou(id) {
        this.$confirm("此操作将扣款", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.jgZiJinDongJieFK({
            ufa_id: id,
            admin_id: this.user.id,
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.dongJieList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 退费
      handleDelete(id) {
        this.$confirm("此操作将退费", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.jgZiJinDongJieTuiFei({
            ufa_id: id,
            admin_id: this.user.id,
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.dongJieList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/jgAdmin/jgFrozen',
          query: {
            pageNum: this.page.pageNum,
            key: this.search,
          }
        })
      },
    },
    filters: {
      til(val) {
        let _str = ""
        switch (val) {
          case 1 :
            _str = "面试邀请"
            break
          case 2 :
            _str = "预存工资"
            break

        }
        return _str
      },

    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.dongJieList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;


    .search {
      width: 220px;
      position: absolute;
      right: 80px;
      border-radius: 4px !important;
    }

    .btn {
      position: absolute;
      left: 0px;
      padding: 10px 40px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;

    .btn-box {
      display: flex;
      align-items: center;
      justify-content: space-around;

      .btns {
        width: 60px;
        height: 30px;
        padding: 0;
      }
    }

    .page-box {
      position: absolute;
      /*left: 0;*/
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .el-table th > .cell {
    text-align: center !important;
  }
</style>